import React from 'react';
import './PageStyles.css';

const Music: React.FC = () => {
  const musicEvents = [
    {
      date: "Friday, Dec 27",
      artist: "The Local Legends",
      genre: "Rock & Blues",
      time: "8:00 PM - 11:00 PM",
      description: "High-energy rock and blues covers"
    },
    {
      date: "Saturday, Dec 28",
      artist: "Acoustic Souls",
      genre: "Folk & Acoustic",
      time: "7:30 PM - 10:30 PM",
      description: "Intimate acoustic performances"
    },
    {
      date: "Friday, Jan 3",
      artist: "Jazz Fusion Collective",
      genre: "Jazz & Fusion",
      time: "8:00 PM - 11:00 PM",
      description: "Smooth jazz and modern fusion"
    },
    {
      date: "Saturday, Jan 4",
      artist: "Country Roads Band",
      genre: "Country & Folk",
      time: "7:30 PM - 10:30 PM",
      description: "Classic and modern country hits"
    }
  ];

  return (
    <div className="page-container">
      <div className="page-header">
        <h1>Live Music</h1>
        <p>Join us for unforgettable live music experiences every weekend</p>
      </div>

      <div className="music-container">
        <div className="music-info">
          <h2>About Our Music</h2>
          <p>
            At Burbanks, we believe great food deserves great music. Every Friday and Saturday night,
            we feature live performances from talented local and touring musicians. From rock and blues
            to acoustic folk and jazz, our diverse lineup ensures there's something for everyone.
          </p>
          <p>
            No cover charge - just come hungry for good food and great music!
          </p>
        </div>

        <div className="events-section">
          <h2>Upcoming Shows</h2>
          <div className="events-grid">
            {musicEvents.map((event, index) => (
              <div key={index} className="event-card">
                <div className="event-date">{event.date}</div>
                <h3 className="event-artist">{event.artist}</h3>
                <div className="event-genre">{event.genre}</div>
                <div className="event-time">{event.time}</div>
                <p className="event-description">{event.description}</p>
              </div>
            ))}
          </div>
        </div>

        <div className="booking-info">
          <h2>Want to Perform?</h2>
          <p>
            Are you a musician interested in performing at Burbanks? We're always looking for
            talented artists to add to our lineup.
          </p>
          <a href="/contact" className="contact-link">Get in touch with us</a>
        </div>
      </div>
    </div>
  );
};

export default Music; 